function getLocalStorageData(key: string, defaultValue: string) {
  try {
    if (typeof key !== 'string') {
      throw new Error(`Unable to get localStorage data - key argument is not a string: ${typeof key} ${key}.`);
    }

    return window.localStorage.getItem(key) ?? defaultValue;
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Error occurred while getting localStorage data with key: ${typeof key} ${key}.`, e);
  }

  return defaultValue;
}

function getBooleanLocalStorageData(key: string, defaultValue: boolean) {
  const dataString = getLocalStorageData(key, defaultValue.toString());

  if (dataString === 'true') {
    return true;
  }

  if (dataString === 'false') {
    return false;
  }

  return defaultValue;
}

function setLocalStorageData(key: string, value: string) {
  try {
    if (typeof key !== 'string') {
      throw new Error(`Unable to set localStorage data - key argument is not a string: ${typeof key} ${key}.`);
    }

    if (typeof value !== 'string') {
      throw new Error(`Unable to set localStorage data with key: ${key} - value argument is not a string: ${typeof value} ${value}.`);
    }

    window.localStorage.setItem(key, value);

    window.sc3WorkbenchLogger.info(`Successfully set localStorage data with key: ${key} to value: ${value}.`);
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Error occurred while setting localStorage data with key: ${typeof key} ${key} and value: ${typeof value} ${value}.`, e);
  }
}

function removeLocalStorageData(key: string) {
  try {
    if (typeof key !== 'string') {
      throw new Error(`Unable to remove localStorage data - key argument is not a string: ${typeof key} ${key}.`);
    }

    window.localStorage.removeItem(key);

    window.sc3WorkbenchLogger.info(`Successfully removed localStorage data with key: ${key}.`);
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Error occurred while removing localStorage data with key: ${key}.`, e);
  }
}

export function useLocalStorage() {
  return {
    getLocalStorageData,
    getBooleanLocalStorageData,
    setLocalStorageData,
    removeLocalStorageData
  };
}
